import { render } from "./transfer_money_to.vue?vue&type=template&id=544cd398&scoped=true"
import script from "./transfer_money_to.vue?vue&type=script&lang=js"
export * from "./transfer_money_to.vue?vue&type=script&lang=js"

import "./transfer_money_to.vue?vue&type=style&index=0&id=544cd398&lang=scss&scoped=true"

import exportComponent from "D:\\Abdulahad\\Front end\\at_rp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-544cd398"]])

export default __exports__